/**
 * Helpers for story word matching (see backend/services/story_annotations.py).
 * A sentence is { text, en, w: [{ t, g, l? }] }; units appear in order in `text`.
 */

/**
 * Split a sentence into renderable pieces:
 *   { type: 'unit', index, unit, text } for each unit found in order,
 *   { type: 'gap', text, hasWords }     for the text between units.
 * Units that can't be found (shouldn't happen after server validation) are skipped.
 */
export function layoutSentence(text = '', units = []) {
  const pieces = [];
  let cursor = 0;
  (units || []).forEach((unit, index) => {
    if (!unit || !unit.t) return;
    const at = text.indexOf(unit.t, cursor);
    if (at < 0) return;
    if (at > cursor) pieces.push(gap(text.slice(cursor, at)));
    pieces.push({ type: 'unit', index, unit, text: unit.t, start: at, end: at + unit.t.length });
    cursor = at + unit.t.length;
  });
  if (cursor < text.length) pieces.push(gap(text.slice(cursor)));
  return pieces;
}

function gap(text) {
  return { type: 'gap', text, hasWords: /[\p{L}\p{N}]/u.test(text) };
}

/** Words inside a gap (for "make this tappable"), with their offset inside the gap. */
export function gapWords(text) {
  const out = [];
  const re = /[^\s.,;:!?¡¿…"'“”‘’«»()[\]—–-]+/gu;
  let m;
  while ((m = re.exec(text)) !== null) {
    if (/[\p{L}\p{N}]/u.test(m[0])) out.push({ word: m[0], offset: m.index });
  }
  return out;
}

/** Deep copy (annotations are plain JSON). */
export const cloneAnnotations = (a) => (a ? JSON.parse(JSON.stringify(a)) : a);

/** Lowercased, apostrophe-normalized key for matching against vocabulary. */
export const vocabKey = (s) => (s || '').replace(/[’‘`]/g, "'").trim().toLowerCase();
